/**
 * 콘텐츠 정책 — 외부 링크 / 이모지 검출 및 차단.
 *
 * 부냥 정책:
 *   - 외부 링크 금지 (voonang.com 외 도메인 일체 비활성)
 *   - 정보형 UI에 이모지 금지
 *
 * 사용처:
 *   - 백엔드 detailed_description / description의 렌더링 sanitizer
 *   - 외부 URL prop 검증
 *   - SafeLink 컴포넌트 (외부 URL은 자동 무력화)
 */

/** 부냥 내부 도메인 화이트리스트. */
export const INTERNAL_DOMAINS = ['voonang.com', 'www.voonang.com', 'localhost'] as const;

/** URL이 voonang.com 내부인지 확인. */
export function isInternalUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  // 상대 경로는 내부
  if (url.startsWith('/') || url.startsWith('#') || url.startsWith('?')) return true;
  // tel:, mailto:, kakaotalk: 등 스킴은 허용 (외부 도메인 아님)
  if (/^(tel|mailto|kakaotalk):/i.test(url)) return true;
  try {
    const u = new URL(url);
    return INTERNAL_DOMAINS.some((d) => u.hostname === d || u.hostname.endsWith(`.${d}`));
  } catch {
    return false;
  }
}

/** 외부 링크 검출. */
export function isExternalUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return !isInternalUrl(url);
}

/**
 * 이모지 제거 (정규식 기반).
 *
 * 유니코드 emoji 범위 + ZWJ + variation selector 제거.
 * 한자·한글·일반 기호는 보존.
 */
export function stripEmoji(text: string): string {
  if (!text) return '';
  return text
    .replace(
      /[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2B00}-\u{2BFF}]/gu,
      '',
    )
    .replace(/[\u{200D}\u{FE0F}\u{FE0E}]/gu, '')
    .replace(/[\u{1F1E6}-\u{1F1FF}]{2}/gu, ''); // 국기 (regional indicator pair)
}

/** 이모지 존재 여부. */
export function hasEmoji(text: string | null | undefined): boolean {
  if (!text) return false;
  return stripEmoji(text) !== text;
}
